'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InlineOverlayBody = require('./components/InlineOverlayBody.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InlineOverlayBody).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-inline-overlay/lib/components/inline-overlay-body/index.js
// module id = 1318
// module chunks = 1